module.exports = __webpack_public_path__ + "media/images/arrow-left-9f2d63a9.png";